import { useGlobalPageTrackEvents } from 'presentation/events/hooks/useGlobalPageTrackEvents';
import { useSyncMobilePromotionDetails } from 'presentation/events/hooks/useSyncMobilePromotionDetails';
import { useAdobeTargetPageView } from 'presentation/events/hooks/adobe/useAdobeTargetPageView';
import { useTrackBlueTriangle } from 'presentation/events/hooks/useTrackBlueTriangle';
import { useTrackGlobalPageLoad } from 'presentation/events/hooks/useTrackGlobalPageLoad';
import { useTrackSelectPromotion } from 'presentation/events/hooks/useTrackSelectPromotion';
import { useTrackUTMSearchParams } from 'presentation/events/hooks/useTrackUTMSearchParams';
import { useTrackViewPromotion } from 'presentation/events/hooks/useTrackViewPromotion';

export const TrackingHooks = () => {
	useGlobalPageTrackEvents();
	useTrackGlobalPageLoad();
	useTrackViewPromotion();
	useTrackSelectPromotion();
	useTrackUTMSearchParams();
	useTrackBlueTriangle();
	useAdobeTargetPageView();
	useSyncMobilePromotionDetails();
	return null;
};
